import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllQualidadeMelhoriasUseCase } from "../../../presentation/useCases/read/get_all_qualidade_acoes_melhorias_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { AcoesMelhorialListaFilter } from "../../models/acoes_melhorias_filter";
import { AcoePreventivasLista } from "../../models/acoes_melhorias_lista";


// GetAllQualidadeAcoesMelhoriasServicoUseCase


export class GetAllQualidadeAcoesMelhoriasServicoUseCase
  extends BasePaginatedUseCase<AcoePreventivasLista>
  implements IGetAllQualidadeMelhoriasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemAcoesMelhorias(
    filter: AcoesMelhorialListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {


    const response = await this.repository
      .getAllListagemAcoesMelhorias(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
